import PropTypes from 'prop-types';
import { BoundIcon } from '@eti/components';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { DIRECTIONS, useDirection, useSiteContext, useTranslation } from '@eti/providers';
import { constants, duration as durationUtil, string } from '@eti/utils';
import Stops from './Stops';
import { DurationWrapper } from './styles/tripDetailsSegment';

const { LTR } = DIRECTIONS;
const { unicodeControlCharacters } = constants;
const { LRE, PDF } = unicodeControlCharacters;

const labelStyles = css`
  font-size: 0.625rem;
  margin-bottom: 3px;

  @media ${mediaQueries.medium.up} {
    font-size: 0.75rem;
  }

  @media ${mediaQueries.large.up} {
    font-size: 0.875rem;
  }
`;

const textStyles = css`
  color: ${etiColors.grayScale[9]};
  font-size: 0.625rem;
  text-align: center;
  word-break: break-word;
`;

const iconStyles = (direction) => css`
  max-width: 56px;
  transform: rotate(${direction === LTR ? 0 : '180deg'});
  width: 100%;

  @media ${mediaQueries.medium.up} {
    width: 76px;
  }

  @media ${mediaQueries.large.up} {
    width: 76px;
  }
`;

const TripDetailsDuration = ({ duration, stops = 0, numberOfTechnicalStops, isExpanded }) => {
  const { direction } = useDirection();
  const { language, timeFormat } = useSiteContext();
  const { t } = useTranslation();

  const numberOfTechnicalStopsContent = numberOfTechnicalStops ? (
    <p className={textStyles}>
      {string.insertArgument(
        t('TripDetails.Details.NumberOfTechnicalStops'),
        numberOfTechnicalStops,
      )}
    </p>
  ) : null;

  return (
    <DurationWrapper>
      <p
        className={labelStyles}
        data-testid="searchResults-segment-duration"
      >{`${LRE}${durationUtil.getDuration(duration, language.code, timeFormat)}${PDF}`}</p>
      <BoundIcon
        className={iconStyles(direction)}
        color={etiColors.grayScale[10]}
        dataTestId="tripdetails-boundicon"
        numberOfSegments={stops}
        size="0.625rem"
      />
      {isExpanded && numberOfTechnicalStopsContent}
      {stops > 0 && <Stops stops={stops} />}
    </DurationWrapper>
  );
};

TripDetailsDuration.propTypes = {
  duration: PropTypes.number,
  isExpanded: PropTypes.bool,
  numberOfTechnicalStops: PropTypes.number,
  stops: PropTypes.number,
};

export default TripDetailsDuration;
